import { useEffect } from 'react';
import { Virtualizer } from '@tanstack/react-virtual';
import { InvestorMessagesRes } from '@dealstack/shared/lib/generated';

interface Props {
	virtualizer: Virtualizer<HTMLDivElement, Element>;
	messages: InvestorMessagesRes['messages'];
	hasNextPage: boolean;
	isFetchingNextPage: boolean;
	fetchNextPage: () => void;
}

export const useInfiniteScroll = ({
	virtualizer,
	messages,
	hasNextPage,
	isFetchingNextPage,
	fetchNextPage,
}: Props) => {
	useEffect(() => {
		const virtualItems = virtualizer.getVirtualItems();
		const [lastItem] = [...virtualItems].reverse();

		if (!lastItem) {
			return;
		}

		if (lastItem.index >= messages.length - 1 && hasNextPage && !isFetchingNextPage) {
			fetchNextPage();
		}
	}, [
		hasNextPage,
		fetchNextPage,
		messages.length,
		isFetchingNextPage,
		virtualizer.getVirtualItems(),
		virtualizer,
	]);
};
